import { Point } from '../../../platform/geom/Point';
import { Organizable } from './Organizable';

const computeLtr = <T extends Iterable<Organizable>>(at: Point, height: number, plots: T): T => {

    const arr = Array.from(plots);
    const cw = Math.max(...arr.map(x => x.width())) + 20;
    const ch = Math.max(...arr.map(x => x.height())) + 20;

    let xa = 0;
    let ya = 0;

    for (const p of plots) {
        if (ya > height) {
            xa += cw;
            ya = 0;
        }
        p.moveTo(xa, ya);
        ya += ch;
    }

    // return Plots.centerTo(plots, at);
    return plots;
};

export const StackLayout = { computeLtr };
